import request from '../request.js';
import { uploadFile } from './common';

/**
 * 获取用户信息API
 * @returns 用户信息
 */
export const getUserInfo = async (id) => {
  try {
    const result = await request.get(`/client/tender/cli_user/${id}`, null, {
      retry: 2,
      loading: true
    });
    
    return result;
  } catch (error) {
    console.error('获取第三方用户信息失败:', error);
    throw error;
  }
};

/**
 * 获取邀请记录
 * @param params 查询参数，如页码、每页数量等
 * @returns 邀请记录列表
 */
export const getInviteRecords = async (params = {}) => {
  try {
    const result = await request.get('/cli/user/v1/invite/records', params, {
      retry: 1
    });
    
    return result;
  } catch (error) {
    console.error('获取邀请记录失败:', error);
    throw error;
  }
};

/**
 * 更新用户信息API
 * @param data 用户信息数据
 * @returns 更新结果
 */
export const updateUserInfoApi = async (data) => {
  try {
    const result = await request.put('/client/tender/cli_user', data, {
      retry: 1,
      // showSuccessMessage: '更新成功'
    });
    
    return result;
  } catch (error) {
    console.error('更新第三方用户信息失败:', error);
    throw error;
  }
};

/**
 * 修改密码API
 * @param params 参数对象，包含mobile、smsCaptcha、countryCode、password、password2
 * @returns 修改结果
 */
export const setPassword = async (params = {}) => {
  try {
    const result = await request.post('/client/login/setPassword', params, {
      retry: 1,
      // showSuccessMessage: '密码修改成功'
    });
    
    return result;
  } catch (error) {
    console.error('修改密码失败:', error);
    throw error;
  }
};









/**
 * 注销账号API
 * @param params 参数对象，包含password用于验证
 * @returns 注销结果
 */
export const logOffAccount = async (params = {}) => {
  try {
    const { password } = params;
    
    // 模拟API调用延迟
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // 模拟密码验证逻辑
    if (password) {
      // 在实际应用中，这里应该是一个真实的密码验证请求
      // 这里我们模拟一个简单的验证逻辑：密码长度至少为6位
      if (password.length >= 6) {
        return {
          code: 200,
          message: '账号注销成功',
          data: null
        };
      } else {
        return {
          code: 400,
          message: '密码验证失败，请重新输入',
          data: null
        };
      }
    } else {
      return {
        code: 400,
        message: '请输入密码进行验证',
        data: null
      };
    }
  } catch (error) {
    console.error('注销账号失败:', error);
    throw error;
  }
};
